import "./customModal.scss";

import { FC, memo } from "react";

interface IProps {
  message: string;
}

const ErrorNotification: React.FC<IProps> = memo(({ message }) => {
  return <p className="custom-modal__error-notification">{message}</p>;
});

export { ErrorNotification };
